// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ActionSelection_buttons__3X9lQ","sections":"ActionSelection_sections__3WgQG"};